import { useQuery } from '@tanstack/react-query';
import { type Store } from '@fiverr-private/store_builder_types';
import { useInitialProps } from './useInitialProps';

interface ReturnType {
    storeData: Store | undefined;
    lastModified: string;
    isLoading: boolean;
    error: unknown;
    refetch: () => void;
    isStale: boolean;
}

export const useStoreData = (): ReturnType => {
    const { storeData: initialStoreData } = useInitialProps();

    const query = useQuery({
        queryKey: ['store-data'],
        initialData: {
            storeData: initialStoreData,
            lastModified: new Date().toISOString(),
        },
        refetchOnMount: false,
    });

    return {
        storeData: query.data?.storeData,
        lastModified: query.data?.lastModified,
        isLoading: query.isLoading,
        error: query.error,
        refetch: query.refetch,
        isStale: query.isStale,
    };
};
